import { Link } from "react-router-dom";

const features = [
  {
    icon: "ri-database-2-fill",
    title: "漫画网漫画库",
    desc: "海量漫画收录入库，覆盖热血、恋爱、悬疑、奇幻、科幻、搞笑六大品类，持续更新不断完善。",
  },
  {
    icon: "ri-price-tag-3-fill",
    title: "漫画网漫画分类",
    desc: "清晰的分类导航，按题材速查，一秒定位你想看的漫画类型，告别大海捞针。",
  },
  {
    icon: "ri-list-check-2",
    title: "漫画网漫画目录",
    desc: "每部漫画都配有完整章节目录，最新话优先展示，连载进度一目了然，随时续读。",
  },
];

export default function CoverageSection() {
  return (
    <section className="relative overflow-hidden bg-secondary-100/70 py-12 md:py-16" aria-labelledby="coverage-heading">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-200 px-3 py-1 text-xs font-semibold text-secondary-800">
            <i className="ri-secure-payment-line"></i> 收录说明
          </span>
          <h2 id="coverage-heading" className="mt-3 font-display text-2xl font-black text-foreground-900 md:text-3xl">
            收录范围一次全看清
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            漫画网以「漫画网漫画库、漫画网漫画分类、漫画网漫画目录」三位一体的方式组织内容，让你快速找到想看的漫画。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {features.map((f) => (
            <article
              key={f.title}
              className="rounded-lg border border-background-200/70 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 md:p-7"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-600 md:h-14 md:w-14">
                <i className={`${f.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-900 md:text-lg">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </article>
          ))}
        </div>

        {/* CTA band */}
        <div className="relative mt-10 overflow-hidden rounded-lg bg-primary-500 px-6 py-10 text-center md:py-12">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-700/40 to-primary-500/0"></div>
          <div className="relative">
            <h3 className="font-display text-xl font-black text-background-50 md:text-2xl">想看哪部直接进列表</h3>
            <p className="mx-auto mt-2 max-w-xl text-sm text-background-50/90 md:text-base">
              从漫画大全开始，跟着分类与目录快速定位，开启你的漫画阅读之旅。
            </p>
            <Link
              to="/category/all"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
            >
              浏览漫画大全 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}